module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[83]204.e1b4c82.woff2";